import PropTypes from 'prop-types'

const InlineLink = ({ text, href, external = false }) => (
  <a
    href={href}
    className="text-blue-400 hover:text-blue-300 underline underline-offset-2 transition-colors"
    target={external ? '_blank' : undefined}
    rel={external ? 'noopener noreferrer' : undefined}
  >
    {text}
    {external && <span className="ml-1 text-xs">↗</span>}
  </a>
)

InlineLink.propTypes = {
  text: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired,
  external: PropTypes.bool,
}

export default InlineLink
